/**
 * iter250 — PO Wizard Error Boundary
 *
 * Wraps the PO Wizard body so a malformed master snapshot (or any
 * render error inside the wizard) shows a graceful fallback instead
 * of blanking the whole Franchise Onboarding page.
 */
import React from 'react';

export class PowizErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[POWizardV2] render failed', {
      master_snapshot_id: this.props.masterSnapshotId,
      onboarding_id: this.props.onboardingId,
      message: error?.message,
      stack: info?.componentStack,
    });
  }
  reset = () => this.setState({ error: null });
  render() {
    if (this.state.error) {
      return (
        <div className="p-6 space-y-3" data-testid="powiz-error-boundary">
          <div className="text-lg font-semibold text-red-700">
            Unable to load PO Master items.
          </div>
          <div className="text-sm text-muted-foreground">
            Please retry or contact Super Admin.
          </div>
          <div className="text-xs text-muted-foreground break-all">
            {String(this.state.error?.message || this.state.error)}
          </div>
          <div className="flex gap-2 pt-2">
            <button
              className="px-3 py-1 border rounded text-sm hover:bg-muted"
              onClick={this.reset}
              data-testid="powiz-error-retry"
            >Retry</button>
            {this.props.onClose && (
              <button
                className="px-3 py-1 border rounded text-sm hover:bg-muted"
                onClick={() => { this.reset(); this.props.onClose(); }}
                data-testid="powiz-error-close"
              >Close</button>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default PowizErrorBoundary;
